import { createLazyFeature as createSharedLazyFeature } from '../shared/lazy-feature.js';
import { scheduleFeatureRecovery } from './lazy-feature-recovery.js';

export function createLazyFeature<Value>(
  load: () => Promise<Value>,
  { automaticRecovery = true }: { automaticRecovery?: boolean } = {},
): () => Promise<Value> {
  return createSharedLazyFeature(load, () => {
    if (automaticRecovery) scheduleFeatureRecovery();
  });
}
